<template>
  <v-sheet class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
    <v-row>
      <v-col cols="12">
        <header-medium :text="$t('Authenticate.Title')" />
      </v-col>
    </v-row>
    <v-row v-if="!mobile" justify="space-around">
      <v-col cols="6" md="4" v-if="!hideSMS">
        <v-card class="mx-auto" max-width="450" @click="startSms">
          <v-card-text>
            <p class="text-h4 text--primary pb-2">{{ $t("Authenticate.info_text_twilio_sms") }}</p>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <v-icon>mdi-message-text</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.sms") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="4">
        <v-card class="mx-auto" max-width="450" @click="startPhone">
          <v-card-text>
            <p class="text-h4 text--primary">{{ $t("Authenticate.info_text_twilio_telephone") }}</p>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <v-icon>mdi-phone</v-icon>
                    </td>
                    <td>{{ $t("Authenticate.phone") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-container class="ma-0 pa-0 mw-100" v-if="mobile">
      <v-row justify="space-around">
        <v-col cols="12" sm="12" v-if="!hideSMS">
          <v-card class="mx-auto" max-width="450" @click="startSms">
            <v-card-text>
              <p class="text-h4 text--primary pb-2">{{ $t("Authenticate.info_text_twilio_sms") }}</p>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>
                        <v-icon>mdi-message-text</v-icon>
                      </td>
                      <td>{{ $t("Authenticate.sms") }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="12" sm="12">
          <v-card class="mx-auto" max-width="450" @click="startPhone">
            <v-card-text>
              <p class="text-h4 text--primary">{{ $t("Authenticate.info_text_twilio_telephone") }}</p>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>
                        <v-icon>mdi-phone</v-icon>
                      </td>
                      <td>{{ $t("Authenticate.phone") }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="ma-0 pa-0 mw-100" v-if="!mobile">
      <v-row class="pt-5" dense>
        <v-col cols="12" sm="4" class="text-left">
          <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
        </v-col>
        <v-col cols="12" sm="8" class="text-right">
          <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="ma-0 pa-0 mw-100" v-if="mobile">
      <v-row class="pt-5" dense>
        <v-col cols="12" class="text-left">
          <custom-button block :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
        </v-col>
        <v-col cols="12" class="text-left">
          <custom-button block :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton.vue";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import AesAuthenticate from './AesAuthenticate.vue';
import i18n from "@/i18n";
import cookie from "vue-cookies";
import libphonenumbers from "libphonenumbers";

export default {
  name: "aes-authenticate",
  title: i18n.t("Authenticate.Title"),
  components: {
    HeaderMedium,
    CustomButton,
    AesAuthenticate
  },
  data() {
    return {
      mainColor: this.$vuetify.theme.themes.light.primary,
      workflow: null,
      hideSMS: false,
      iframe: {
        src: "",
      },
      mobile: false
    };
  },
  created: async function () {
    this.$emit("step", 3);
    this.mobile = this.$vuetify.breakpoint.mdAndDown;
    this.workflow = this.currentWorkflow;
    this.color = this.$vuetify.theme.themes.light.primary;
    this.$store.commit("set_loading", false);
    this.checkMobileOrLandline();

    if (!this.currentFiles) {
      await this.$store
        .dispatch("data/getWorkflowFiles")
        .then(async (data) => {
          this.files = data;
          this.currentFile = this.files[0];
          this.files[0].completed = true;
          this.files[0].newForm = false;
        })
        .catch((err) => {
          console.log(err)
        });
    }
  },
  computed: {
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
    currentFiles() {
      return this.$store.state.data.files;
    },
  },
  methods: {
    checkMobileOrLandline() {
      let phone = this.workflow.phone
      let phoneUtil = libphonenumbers.PhoneNumberUtil.getInstance();
      let number = phoneUtil.parseAndKeepRawInput(phone);

      if (phoneUtil.getNumberType(number) == 0) {
        this.hideSMS = true
      }
    },
    cancel() {
      this.$emit("refuse", true);
    },
    nextPage(val) {
      this.$store.state.auth.workflow = this.workflow;
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/documents"
      );
      this.$store.commit("set_loading", true);
    },
    async startSms() {
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/authenticate/twilio/sms"
      );
    },
    startPhone() {
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/authenticate/twilio/phone"
      );
    }
  },
};
</script>